import { Container } from '@ui/wrapper'
import { SectionWrapper, StyledText, StyledTitle } from './style'

const EinfuehrungArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.texts?.[0] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data.texts[0].content
            }}
          />
        )}
        {data?.headings?.[0] && (
          <StyledTitle
            as={data.headings[0].level}
            dangerouslySetInnerHTML={{
              __html: data.headings[0].content
            }}
          />
        )}
        {data?.texts?.[1] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data.texts[1].content
            }}
          />
        )}
        {data?.images?.[0] && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBlockStart: '80px',
              marginBlockEnd: '40px'
            }}
          >
            <div style={{ maxWidth: 1000, width: 1000 }}>
              <img
                src={
                  data.images[0].src.localFile.publicURL || data.images[0].src
                }
                alt={data.images[0].src.alternativeText || ''}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        )}
        {data?.texts?.[2] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data.texts[2].content
            }}
          />
        )}
        {data?.items?.[0] && (
          <>
            <StyledTitle
              style={{ marginTop: 35 }}
              as={data.headings[1].level}
              dangerouslySetInnerHTML={{
                __html: data.headings[1].content
              }}
            />
            <StyledText
              dangerouslySetInnerHTML={{
                __html: data.items[0].title
              }}
            />
            <StyledText>
              {data.items[0].texts.map((t, index) => (
                <ul
                  style={{ listStyleType: 'disc', marginLeft: '1em' }}
                  key={index}
                >
                  <li key={index}>{t.content}</li>
                </ul>
              ))}
            </StyledText>
          </>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default EinfuehrungArea
